// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/installation.css
// module id = 1294
// module chunks = 32